import type { IApiCurrency, IApiCurrencyModel } from '@/modules/currenciesModule/types/currencies'
export const Currency = (json: IApiCurrency): IApiCurrencyModel => {
	const fromJSON = (json: IApiCurrency) => {
		const { currency_from, currency_to, rate, ...rest } = json
		return {
			currencyFrom: currency_from,
			currencyTo: currency_to,
			rate: Number(rate),
			...rest,
		}
	}
	return { ...fromJSON(json) }
}
